import { useGetMailMessageByIdQuery } from "../../../services/useremails";
import { MailMessageData } from "../../../types/MailMessageData";

export type useGetMailMessageByGraphIdProps = {
    data: MailMessageData | null
    error: Error | string | null
    isError: boolean
    isLoading: boolean

};

const useGetMailMessageByGraphId = (userId: string, folderId: string, mailId: string) : useGetMailMessageByGraphIdProps => {
    const { data, isLoading, isFetching, isError, error } = useGetMailMessageByIdQuery({ userId, folderId, mailId });
    return {
        data: data || null,
        error,
        isLoading: isLoading || isFetching,
        isError
    };
};

export default useGetMailMessageByGraphId;